export default "__VITE_ASSET__BBLOPAbk__"